<script>
    import AccountHeader from "../../components/account/AccountHeader.svelte";
    import AccountNav from "../../components/account/AccountNav.svelte";
    import {userData} from "../../js/stores";
    import {prepareAddressBody} from "../../lib/prepareAddressBody";
    import {API_URL} from "../../../env";
    import {push, replace} from "svelte-spa-router";
    import checkAddressBody from "../../lib/checkAddressBody";
    import checkLoginValidity from "../../lib/checkLoginValidity";
    import {addAlert} from "../../js/alert";

    window.scrollTo(0, 0);
    if ($userData === null) replace("/?m=prihlasit-sa")

    let buttons = {
        hasAnotherBillingAddress: false,
        isCompany: false
    }

    let form = {
        name: $userData?.name || "",
        surname: $userData?.surname || "",
        email: $userData?.email || "",
        phone: "",
        country: "Slovensko",
        street: "",
        city: "",
        zip: "",

        billing_country: "",
        billing_street: "",
        billing_city: "",
        billing_zip: "",

        ico: "",
        dic: "",
        company: "",
        ic_dph: "",
    }

    let bad = {
        name: false,
        surname: false,
        phone: false,
        street: false,
        city: false,
        zip: false,

        billing_country: false,
        billing_street: false,
        billing_city: false,
        billing_zip: false,

        company: false,
        ico: false,
    }


    let isSaving = false
    async function handleSave() {
        if (isSaving) return;
        isSaving = true

        const isBad = checkAddressBody(form, buttons)
        if (isBad.bad) {
            bad = isBad.body
            addAlert("danger", "Chyba", "Niektoré polia nie sú správne vyplnené.")
            return isSaving = false
        }

        const body = prepareAddressBody(form, buttons)

        const res = await fetch(API_URL + '/users/addresses', {
            method: 'POST',
            credentials: "include",
            headers: {
                "Content-Type" : "application/json"
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            isSaving = false
            if (checkLoginValidity(res.status)) return await push("/?m=prihlasit-sa");
            addAlert("danger", "Chyba", "Adresu sa nepodarilo uložiť. Skúste to prosím znova.")
        } else {
            await push("/ucet/adresy")
            isSaving = false
        }
    }
</script>

<section class="container" id="account">
    <AccountHeader/>

    <div class="account">

        <AccountNav/>

        <div class="account-content">
            <h3>NOVÁ ADRESA <a href="#/ucet/adresy" class="float-right"><i class="fas fa-fw fa-arrow-left"></i>SPÄŤ NA ADRESY</a></h3>
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="custom-span">DORUČOVACIA ADRESA</div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="firstname">Meno</label>
                        <input id="firstname" name="firstName" type="text" placeholder="Meno" bind:value={form.name} class:unfilled={bad.name} maxlength="32">
                    </div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="surname">Priezvisko</label>
                        <input id="surname" name="lastName" type="text" placeholder="Priezvisko" bind:value={form.surname} class:unfilled={bad.surname} maxlength="32">
                    </div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="email">E-mail</label>
                        <input id="email" name="email" type="email" placeholder="E-mail" value={form.email} class:unfilled={bad.email} disabled>
                    </div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="tel">Telefon</label>
                        <input id="tel" name="tel" type="tel" placeholder="Telefon" bind:value={form.phone} class:unfilled={bad.phone}>
                    </div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="country">Krajina</label>
                        <input id="country" name="country" type="text" placeholder="Krajina" maxlength="64" bind:value={form.country} class:unfilled={bad.country} disabled>
                    </div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="street">Ulica a číslo domu</label>
                        <input id="street" name="street" type="text" placeholder="Ulica a číslo domu" maxlength="64" bind:value={form.street} class:unfilled={bad.street}>
                    </div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="psc">PSČ</label>
                        <input id="psc" name="postalCode" type="text" placeholder="PSČ" maxlength="6" bind:value={form.zip} class:unfilled={bad.zip}>
                    </div>
                </div>
                <div class="col-sm-6 col-xl-4 mb-4">
                    <div class="input-group">
                        <label for="city">Mesto / Obec</label>
                        <input id="city" name="city" type="text" placeholder="Mesto / Obec" maxlength="40" bind:value={form.city} class:unfilled={bad.city}>
                    </div>
                </div>
                <div class="col-sm-6 mb-4">
                    <div class="order-check">
                        <input class="checkbox_animated" id="company" type="checkbox" bind:checked={buttons.isCompany}>
                        <label for="company">Nakupujem ako podnikateľ</label>
                    </div>
                </div>
                {#if buttons.isCompany}
                    <div class="col-12 mb-4">
                        <div class="custom-span">ÚDAJE PODNIKATEĽA</div>
                    </div>
                    <div class="col-sm-6 col-xl-4 mb-4">
                        <div class="input-group">
                            <label for="companysec">Spoločnosť</label>
                            <input id="companysec" name="company" type="text" placeholder="Spoločnosť" maxlength="64" bind:value={form.company} class:unfilled={bad.company}>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl-4 mb-4">
                        <div class="input-group">
                            <label for="ico">IČO</label>
                            <input id="ico" name="ico" type="text" placeholder="IČO" maxlength="10" bind:value={form.ico} class:unfilled={bad.ico}>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl-4 mb-4">
                        <div class="input-group">
                            <label for="dic">DIČ (voliteľné)</label>
                            <input id="dic" name="dic" type="text" placeholder="DIČ (voliteľné)" maxlength="14" bind:value={form.dic} class:unfilled={bad.dic}>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl-4 mb-4">
                        <div class="input-group">
                            <label for="icdph">IČ DPH (voliteľné)</label>
                            <input id="icdph" name="icDph" type="text" placeholder="IČ DPH (voliteľné)" maxlength="14" bind:value={form.ic_dph} class:unfilled={bad.ic_dph}>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4 mb-4">
                        <div class="input-group">
                            <label for="formBillingTown">Mesto / Obec</label>
                            <input class:unfilled={bad.billing_city} id="formBillingTown" type="text" bind:value={form.billing_city} placeholder="Mesto / Obec" maxlength="40">
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4 mb-4">
                        <div class="input-group">
                            <label for="formBillingStreet">Adresa spoločnosti</label>
                            <input class:unfilled={bad.billing_street} id="formBillingStreet" type="text" bind:value={form.billing_street} placeholder="Adresa spoľočnosti" maxlength="64">
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4 mb-4">
                        <div class="input-group">
                            <label for="formBillingPSC">PSČ</label>
                            <input class:unfilled={bad.billing_zip} id="formBillingPSC" type="text" bind:value={form.billing_zip} placeholder="PSČ" maxlength="6">
                        </div>
                    </div>
                {/if}
            </div>
            <div class="row">
                <div class="col-sm-12 mt-4 mt-sm-0 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-responsive" on:click={handleSave}>
                        {#if isSaving}
                            <i class="fas fa-fw fa-spinner-third fa-spin mr-2"></i>
                        {:else}
                            <i class="fas fa-fw fa-save mr-2"></i>
                        {/if}
                        Uložiť
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>